export default __webpack_public_path__ + "static/VideoCollage-ed31587fdccad3fe7f335c6e70216355.png";